export default __webpack_public_path__ + "static/media/all-college-adminsion-bg.e126ae0e.jpg";